import React from 'react';
import Primary from './progressbar.scss';

const ProgressBar = (props) => {
  //eslint-disable-next-line prefer-const
  let { bgcolor, completed, variant } = props;
  bgcolor = Primary.progressBarFillBg; //bgcolor ? bgcolor : Primary.progressBarFillBg;

  let containerStyles = {
    height: '15px',
    backgroundColor: Primary.progressBarBg,
    borderRadius: '50px',
  };

  let fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: bgcolor,
    borderRadius: 'inherit',
    textAlign: 'right',
  };

  if (variant === 'secondary') {
    containerStyles = {
      height: '4px',
      backgroundColor: 'var(--Primary-Grey)',
      borderRadius: 0,
    };
    fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      backgroundColor: 'var(--Secondary-Grey)',
      borderRadius: 'inherit',
      textAlign: 'right',
    };
  }

  return (
    <div style={containerStyles} className="progressbar">
      <div style={fillerStyles}></div>
    </div>
  );
};

export default ProgressBar;
